import { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

const ProfileMenuSkeleton = (): ReactNode => (
  <div
    className={`static inset-0 flex h-fit w-full flex-col overflow-auto rounded-md bg-bg-primary last:border-b-transparent lg:absolute lg:w-[250px]`}
  >
    <div className="border-b border-b-text-secondary/10 p-5">
      <Skeleton className="my-0.5 h-5 rounded-sm" />
    </div>
    <div className="border-b border-b-text-secondary/10 p-5">
      <Skeleton className="my-0.5 h-5 rounded-sm" />
    </div>
    <div className="border-b border-b-text-secondary/10 p-5">
      <Skeleton className="my-0.5 h-5 rounded-sm" />
    </div>
    <div className="border-b border-b-text-secondary/10 p-5">
      <Skeleton className="my-0.5 h-5 rounded-sm" />
    </div>
    <div className="border-b border-b-text-secondary/10 p-5">
      <Skeleton className="my-0.5 h-5 rounded-sm" />
    </div>
  </div>
)

export default ProfileMenuSkeleton
